import { DataTestable, DataTestableState, DataTestGitModel } from '@y42/data-test';
import { ImpexChildState, ImpexChildStoreModel, ImpexChildUIModel } from '@y42/impex';
import { JobStoreModel } from '@y42/job';
import type { DatasourceTableJobUIModel } from '../datasource-table-job/datasource-table-job.model';
import type { DatasourceStoreModel } from '../datasource/datasource.model';
import type { DatasourceTableSettingsGitModel } from './datasource-table-settings.model';

export class DatasourceTableStoreModel
  extends ImpexChildStoreModel<DatasourceTableSettingsGitModel>
  implements DataTestable
{
  constructor(model: DatasourceTableStoreModel) {
    super(model);
    this.tests = model.tests ? new DataTestGitModel(model) : undefined;
  }

  tests?: DataTestGitModel;
  latest_valid_job?: JobStoreModel;
}

export interface DatasourceTableUIModel
  extends Omit<DatasourceTableStoreModel, 'latest_valid_job'>,
    ImpexChildUIModel<DatasourceTableSettingsGitModel, DatasourceTableJobUIModel> {
  datasource: DatasourceStoreModel;
  latest_valid_chain_parent?: DatasourceTableJobUIModel;
}

export interface DatasourceTableState
  extends ImpexChildState<DatasourceTableStoreModel>,
    DataTestableState<DatasourceTableStoreModel> {}
